import type { SxProps, Theme } from '@mui/material/styles';
import { abyssColors } from '@/theme/colors';

export const qaqcPanelHeaderBarBaseSx: SxProps<Theme> = {
  flexShrink: 0,
  position: 'sticky',
  top: 0,
  zIndex: 2,
  px: '1rem',
  py: '1rem',
  backgroundColor: 'background.paper',
};

export const qaqcPanelHeaderBarDefaultSx: SxProps<Theme> = {
  ...qaqcPanelHeaderBarBaseSx,
  borderBottom: `0.0625rem solid ${abyssColors.primary[100]}`,
};

export const qaqcPanelNoTemplateRootSx: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  height: '100%',
  overflow: 'hidden',
};

export const qaqcPanelNoTemplateBodySx: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflowY: 'auto',
  overflowX: 'hidden',
  p: '1.5rem',
  minHeight: 0,
};

export const qaqcPanelNoTemplateColumnSx: SxProps<Theme> = {
  width: '100%',
  maxWidth: 'min(100%, 48rem)',
};

export const qaqcPanelNoTemplateGraphicWrapperSx: SxProps<Theme> = {
  maxWidth: { md: '12rem', xl: '14.375rem' },
  display: 'flex',
  justifyContent: 'center',
  '& img': {
    maxWidth: { md: '6.25rem', xl: '8.3125rem' },
    width: 'auto',
  },
};

export const qaqcPanelNoTemplateMessageRowSx: SxProps<Theme> = {
  marginTop: { md: '1.25rem', xl: '2.5rem' },
  width: '100%',
};
